import React from 'react'
import { Typography } from '@material-ui/core'

const TYPES = [
  { id: 'Text', label: 'Text' },
  { id: 'Image', label: 'Image' },
  { id: 'Bar', label: 'Bar' },
  { id: 'ColorBox', label: 'Color box' },
]

const typeOf = (field) => (TYPES.some((t) => t.id === field?.dataType) ? field.dataType : 'Text')

// One-click "select every placed field of this type". Shift/Ctrl/Cmd-click adds to the
// current selection instead of replacing it.
export default function SelectByType({ placements, fields, selection, onSelect }) {
  const idsByType = {}
  placements.forEach((p) => {
    const field = fields.find((f) => f.key === p.fieldId)
    if (!field) return
    const type = typeOf(field)
    ;(idsByType[type] = idsByType[type] || []).push(p.fieldId)
  })
  const present = TYPES.filter((t) => idsByType[t.id])
  if (placements.length < 2 || present.length === 0) return null

  return (
    <div style={{ padding: '8px 12px 4px', borderBottom: '1px solid #eee' }}>
      <Typography variant='caption' color='textSecondary' style={{ display: 'block', marginBottom: 4 }}>Select all</Typography>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, paddingBottom: 4 }}>
        {present.map(({ id, label }) => {
          const ids = idsByType[id]
          const active = ids.length === selection.length && ids.every((key) => selection.includes(key))
          return (
            <button
              key={id}
              type='button'
              aria-pressed={active}
              aria-label={`Select all ${label.toLowerCase()} fields (${ids.length})`}
              onClick={(e) => onSelect(ids, e.shiftKey || e.metaKey || e.ctrlKey)}
              style={{
                height: 24,
                padding: '0 8px',
                borderRadius: 12,
                fontSize: 11,
                fontFamily: 'inherit',
                cursor: 'pointer',
                border: '1px solid #1976d2',
                background: active ? '#1976d2' : '#fff',
                color: active ? '#fff' : '#1976d2',
              }}
            >
              {label} {ids.length}
            </button>
          )
        })}
      </div>
    </div>
  )
}
